import PropTypes from "prop-types";
import RoleGuard from "./RoleGuard";

const ProductAdminRoute = ({ user, children }) => (
  <RoleGuard user={user} allowedRoles={["productAdmin"]}>
    {children}
  </RoleGuard>
);

ProductAdminRoute.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node.isRequired,
};

ProductAdminRoute.defaultProps = {
  user: null,
};

export default ProductAdminRoute;